import { TableRowProps } from "../../molecules/TableRow/TableRowAtom";
import { ItemsTable } from "../../network/models/TableInterfaces";
import { createCurrencyCell, createInfoCell } from "../../utilities/CreateCell";
import { createRow } from "../../utilities/CreateRow";

export const createVerifiedItemsRows = (data: Array<ItemsTable>) => {
  const rows: Array<TableRowProps> = [];
  data.forEach((entry) => {
    const isFull = entry.fullQuantity !== 0;
    console.log(entry);
    const row: TableRowProps = createRow(
      createInfoCell(entry.ndc), //NDC
      createInfoCell(entry.manufacturer), //Manufacturer
      createInfoCell(entry.description), //Product
      createInfoCell(entry.packageSize.toString()), //Pkg Size
      // createInfoCell(entry.requestType), //Type
      createInfoCell(
        entry.fullQuantity
          .toString(10)
          .concat(
            entry.fullQuantity !== 0
              ? entry.isFullQuantityOpened
                ? " F/O"
                : " F/S"
              : ""
          )
      ), //Full Quantity
      createInfoCell(
        entry.partialQuantity
          .toString(10)
          .concat(
            entry.partialQuantity !== 0
              ? " " + entry.packageSize.toString().split(" ")[1]
              : ""
          )
      ), //Partial Quantity
      createInfoCell(entry.controlledSubstanceCode), //CSC
      createCurrencyCell(
        isFull
          ? (parseFloat(entry.extendedActualPrice) !== 0 ? entry.extendedActualPrice : parseFloat(entry.extendedPrice) * 0.7)
          : (parseFloat(entry.extendedUnitActualPrice) !== 0 ? entry.extendedUnitActualPrice : parseFloat(entry.extendedUnitPrice) * 0.7)
      ),
      createInfoCell(entry.expirationDate), //Expiration Date
      createInfoCell(entry.lotNumber), //Lot #
      createInfoCell(entry.status)
    );
    rows.push(row);
  });
  return rows;
};
